import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00F5FF",
    },
    secondary: {
      main: "#00B4D8",
    },
    background: {
      default: "#0b0f15",
      paper: "rgba(26,26,46,0.85)",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#A0E4F1",
    },
  },
  typography: {
    fontFamily: '"Open Sans", Arial, sans-serif',
    h1: {
      fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif",
    },
    h2: {
      fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif",
    },
    h3: {
      fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif",
    },
    h4: {
      fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif",
    },
    h5: {
      fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif",
    },
    h6: {
      fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif",
    },
    button: {
      fontWeight: 600,
      letterSpacing: "0.5px",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 999,
          paddingLeft: "20px",
          paddingRight: "20px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "1px solid rgba(0,245,255,0.25)",
          boxShadow:
            "0 10px 40px rgba(0, 0, 0, 0.35), 0 0 20px rgba(0, 244, 255, 0.2)",
        },
      },
    },
  },
});

export default theme;
